module.exports = __webpack_public_path__ + "img/selected0-min.3fe9f337.png";